module.exports = __webpack_public_path__ + "img/AsianAllianceLogoWaterMark.6a11ce7f.png";